require('./bootstrap');
// Exponer Vue global (Vue 2) para scripts inline existentes
const Vue = require('vue');
window.Vue = Vue.default || Vue;

document.querySelector("meta[name=viewport]").setAttribute('content', 'width=device-width, initial-scale='+(1/window.devicePixelRatio));
